import React from 'react';
import Knowledgebase from '../components/Knowledgebase.tsx';
import { LibraryBig } from 'lucide-react';
import  GraphRAGingest  from '../components/GraphRagPDFingestion.tsx';
const RAGKnowledgebase: React.FC = () => {
  return (
    <>
    <div className="flex items-center gap-3 mb-6 bg-white p-4 border-b border-gray-200">
     
     <h1 className="text-[20px] font-bold">Knowledgebase</h1>
   </div>

    <div className="p-8">
      
      <Knowledgebase />
      <GraphRAGingest />
    </div>
    </>
  );
};

export default RAGKnowledgebase;